module.exports = __webpack_public_path__ + "img/old_1background.b754ccb.webp";